export function loadAxeptio() {
    return new Promise((resolve, reject) => {
      if (document.getElementById('axeptio-script')) {
        resolve();
        return;
      }
  
      const script = document.createElement('script');
      script.id = 'axeptio-script';
      script.src = 'https://static.axept.io/sdk.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Axeptio script failed to load'));
  
      document.head.appendChild(script);
    });
  }